<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-trajectories')" class="fa fa-copy fa-lg pointer" @click="duplicate" :title="uLang('app.duplicate_enrolment')"></i>
        <i v-if="this.$can('update-trajectories')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.trajectory_enrolment') })"></i>
        <i v-if="this.$can('delete-trajectories')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.trajectory_enrolment') })"></i>
    </div>
</template>

<script>
    import { DestroyAlert, SuccessAlert, ErrorAlert } from '~/Swals';

    export default {
        name: 'actions',
        props: ['data', 'index'],

        methods: {
            remove() {
                new DestroyAlert({ text: this.uLang('app.delete_warning_entity', { entity: this.lang('app.trajectory_enrolment') }) })
                    .show()
                    .then(async () => {
                        this.destroy()
                    });
            },

            edit() {
                this.$router.push({ name: 'admin.relations.trajectory-enrolments.edit', params: { relationId: this.data.relation_id, id: this.data.id }})
            },

            duplicate() {
                this.$router.push({ name: 'admin.relations.trajectory-enrolments.duplicate', params: { relationId: this.data.relation_id, id: this.data.id }})
            },

            destroy() {
                window.axios.delete(route('relations.trajectory-enrolments.destroy', {
                    relation: this.data.relation_id,
                    trajectory_enrolment: this.data.id
                })).then(({data}) => {
                    new SuccessAlert({title: uLang('app.trajectory_enrolment'), text: this.uLang('app.entity_removed', { entity: this.lang('app.trajectory_enrolment') })}).show();
                    vue.$emit('reloadTable');
                }).catch(({ response: { status, data } }) => {
                    new ErrorAlert({
                        title: uLang('app.trajectory_enrolment'),
                        text: data.message
                    })
                        .show()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
